module.exports = {"522327001":"者楼街道","522327002":"纳福街道","522327103":"丫他镇","522327104":"巧马镇","522327105":"秧坝镇","522327107":"岩架镇","522327108":"八渡镇","522327109":"冗渡镇","522327110":"坡妹镇","522327111":"双江镇","522327112":"弼佑镇","522327204":"百口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522327.json
// module id = 2508
// module chunks = 0